(ns practitest.frontend.components2.dashboard.charts.bar
  (:require [practitest.frontend.components2.dashboard.charts.bar-render :as render]
            [practitest.frontend.components2.dashboard.chart :as-alias chart]
            [practitest.frontend.components2.dashboard.charts.protocol :as p]
            [practitest.frontend.components2.dashboard.transforms.bar :as transforms]
            [practitest.frontend.components2.dashboard.events :as-alias events]
            [practitest.frontend.components2.dashboard.events.bar :as-alias bar]
            [re-frame.core :as rf]
            ["d3" :as d3]))

;; ============================================================================
;; Configuration
;; ============================================================================
;; By default the bar chart takes the full width/height of the SVG element.
;; To use fixed dimensions instead, set :default-viewbox-width and
;; :default-viewbox-height in chart-config.

(def chart-config
  { ;; --- Layout ---
   :margin          {:top 5 :right 20 :bottom 25 :left 35}
   :group-gap       0.4  ;; inner padding between category groups
   :group-outer-gap 0.2  ;; outer padding at chart edges
   :bar-gap         0.15 ;; padding between bars within a group
   :y-headroom      1.1 ;; y-scale multiplier (1.1 = 10% space above tallest bar)
   :tick-length     6   ;; x-axis tick mark height (px in viewBox)

   ;; --- Legend ---
   :legend-bar-height   12  ;; color swatch height (px in viewBox)
   :legend-bar-gap      2   ;; gap between legend swatches
   :legend-label-gap    18  ;; distance from swatch to label text
   :legend-offset-ratio 0.4 ;; vertical offset within legend area (0-1)

   ;; --- Animation ---
   :exit-duration     250 ;; exit phase (ms)
   :update-duration   350 ;; update phase (ms)
   :enter-duration    200 ;; enter phase (ms)
   :ease-exit         (.-easeCubicIn d3)
   :ease-update       (.-easeCubicInOut d3)
   :ease-enter        (.-easeCubicOut d3)
   :enter-width-ratio 0.5 ;; initial bar width on enter (0-1 of full width)

   ;; --- Vertical split (chart-ratio + legend-ratio = 1.0) ---
   :chart-ratio  0.75   ;; top 75% — axes and bars
   :legend-ratio 0.25}) ;; bottom 25% — color legend

(defmethod p/render! ::chart/bar [chart ctx svg-element]
  (let [toggle-evt #(rf/dispatch [::events/toggle-legend-item (:chart/id chart) %])
        nav-evt    #(rf/dispatch [::events/navigate chart %])
        ctx        (merge chart-config ctx {:on-legend-click toggle-evt
                                            :on-bar-click    nav-evt})]
    (render/render-chart! svg-element chart ctx)))

(defmethod p/transform-data ::chart/bar [chart]
  (transforms/transform chart))
